import { toast } from '@huspy/forge/shared';
import { useMutation } from '@tanstack/react-query';
import queryClient from '@app/queryClient';
import { VaultConfigMutationPayload } from '@modules/vault/api/types';
import { vaultApi } from '@modules/vault/api';
import { t } from 'i18next';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';

const useUpdateVault = (oppId: string, clientId?: string | undefined) => {
  const {
    mutateAsync,
    isPending,
    isSuccess,
  } = useMutation({
    mutationKey: ['updateVault', oppId],
    mutationFn: ({ selected_banks, applicants }: VaultConfigMutationPayload) => {
      if (clientId) {
        trackAmplitudeEvent(
          USER_EVENTS.VAULT.VAULT_DOCUMENTS_CHECKLIST_SAVE_ATTEMPTED,
          { case_id: oppId, client_id: clientId }
        );
      }
      return vaultApi.updateVault(oppId, { selected_banks, applicants });
    },

    onSuccess: () => {
      if (clientId) {
        trackAmplitudeEvent(
          USER_EVENTS.VAULT.VAULT_DOCUMENTS_CHECKLIST_SAVE_COMPLETED,
          { case_id: oppId, client_id: clientId }
        );
      }
      queryClient.refetchQueries({ queryKey: ['vaultConfig', oppId] });
      toast('info', { message: t('vault.mutations.vaultUpdatedSuccess') });
    },
    onError: (error) => {
      if (clientId) {
        trackAmplitudeEvent(
          USER_EVENTS.VAULT.VAULT_DOCUMENTS_CHECKLIST_SAVE_FAILED,
          { error_message: error.message }
        );
      }
      toast('error', { message: error.message });
    },
  });

  return { mutate: mutateAsync, isPending, isSuccess };
};

export default useUpdateVault;
